import React from 'react'
import { css, Global } from '@emotion/core'

// Graphik is used for body text
import GraphikLight from './Graphik/Graphik-Light.otf'
import GraphikNormal from './Graphik/Graphik-Regular.otf'
import GraphikSemiBold from './Graphik/Graphik-Semibold.otf'
import GraphikBold from './Graphik/Graphik-Bold.otf'

// Haptik is used for Headings and UI elements
import HaptikLight from './Haptik/GT-Haptik-Light-2.ttf'
import HaptikNormal from './Haptik/GT-Haptik-Regular-2.ttf'
import HaptikBold from './Haptik/GT-Haptik-Bold-2.ttf'

// will inject a css script in the document head so that font faces are available globally
const GlobalFontStyle = () => (
  <Global
    styles={css`
      @font-face {
        font-family: 'Graphik';
        src: local('Graphik-Light'), local('Graphik-Light.otf'),
          url(${GraphikLight}) format('opentype');
        font-weight: 300;
        font-style: normal;
      }

      @font-face {
        font-family: 'Graphik';
        src: local('Graphik-Regular'), local('Graphik-Regular.otf'),
          url(${GraphikNormal}) format('opentype');
        font-weight: 400;
        font-style: normal;
      }

      @font-face {
        font-family: 'Graphik';
        src: local('Graphik-Semibold'), local('Graphik-Semibold.otf'),
          url(${GraphikSemiBold}) format('opentype');
        font-weight: 600;
        font-style: normal;
      }

      @font-face {
        font-family: 'Graphik';
        src: local('Graphik-Bold'), local('Graphik-Bold.otf'),
          url(${GraphikBold}) format('opentype');
        font-weight: 700;
        font-style: normal;
      }

      @font-face {
        font-family: 'Haptik';
        src: local('GT-Haptik-Light-2'), local('GT-Haptik-Light-2.ttf'),
          url(${HaptikNormal}) format('truetype');
        font-weight: 300;
        font-style: normal;
      }

      @font-face {
        font-family: 'Haptik';
        src: local('GT-Haptik-Regular-2'), local('GT-Haptik-Regular-2.ttf'),
          url(${HaptikLight}) format('truetype');
        font-weight: 400;
        font-style: normal;
      }

      @font-face {
        font-family: 'Haptik';
        src: local('GT-Haptik-Bold-2'), local('GT-Haptik-Bold-2.ttf'),
          url(${HaptikBold}) format('truetype');
        font-weight: 700;
        font-style: normal;
      }
    `}
  />
)

export default GlobalFontStyle
